import React from "react";
import "../../styles/skeleton.css"; // Create this CSS file

const TableSkeleton = ({ columns, rows = 6, hasActions = true }) => {
  return (
    <div className="table-skeleton-container">
      {/* Search and Filter Skeletons */}
      <div className="skeleton-filter-bar">
        <div className="skeleton-search skeleton-shimmer"></div>
        <div className="skeleton-filter skeleton-shimmer"></div>
        <div className="skeleton-filter skeleton-shimmer"></div>
        <div className="skeleton-filter skeleton-shimmer"></div>
        <div className="skeleton-filter skeleton-shimmer"></div>
        <div className="skeleton-filter skeleton-shimmer"></div>
      </div>



      {/* Table Rows Skeletons */}
      <div className="skeleton-table-body">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="skeleton-table-row">
            {columns.map((col, colIndex) => (
              <div key={colIndex} className="skeleton-cell">
                <div className="skeleton-content skeleton-shimmer"></div>
              </div>
            ))}
            {hasActions && (
              <>
                <div className="skeleton-cell">
                  <div className="skeleton-icon skeleton-shimmer"></div>
                </div>

              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export const StudentProfileSkeleton = () => {
  return (
    <div className="student-profile-skeleton-wrapper">

      {/* Top Section */}
      <div className="student-profile-skeleton-top">
        <div className="student-profile-skeleton-avatar"></div>

        <div className="student-profile-skeleton-info">
          <div className="student-profile-skeleton-line sp-w-120"></div>
          <div className="student-profile-skeleton-line sp-w-200"></div>
          <div className="student-profile-skeleton-line sp-w-160"></div>
          <div className="student-profile-skeleton-line" id="student-profile-skeleton-line"></div>


          <div className="student-profile-skeleton-btn sp-w-220"></div>
          <div className="student-profile-skeleton-btn red sp-w-220"></div>
        </div>

      </div>

      {/* Chart Section */}
      <div className="student-profile-skeleton-card">
        <div className="student-profile-skeleton-line sp-w-180"></div>
        <div className="student-profile-skeleton-chart"></div>
      </div>

      {/* Table Section */}
      <div className="student-profile-skeleton-card">
        <div className="student-profile-skeleton-line sp-w-160"></div>
        <div className="student-profile-skeleton-table">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="student-profile-skeleton-row"
            ></div>
          ))}
        </div>
      </div>

    </div>
  );
};



export const InstitutionCardSkeleton = () => {
  return (
    <div className="inst-card-skl">
      <div className="inst-skl inst-skl-avatar"></div>
      <div className="inst-skl inst-skl-subtext"></div>

      <div className="inst-skl-btn-row">
        <div className="inst-skl inst-skl-btn"></div>
        <div className="inst-skl inst-skl-btn"></div>
      </div>
    </div>
  );
};



export const CardSkeleton = ({ color }) => (
  <div className="card-shimmer-modern">
    {/* Top Header */}
    <div className="shimmer-header">
      <div className="shimmer-subheading"></div>
      <div className="shimmer-header-actions">
        <div className="shimmer-action-icon"></div>
      </div>
    </div>
    
    {/* Main Content */}
    <div className="shimmer-main-content">
       <div className="shimmer-value-container">
        <div className="shimmer-main-value"></div>
        <div className="shimmer-value-subtext"></div>
      </div>
      
      <div className="shimmer-logo-container">
        <div 
          className="shimmer-logo" 
          style={{ backgroundColor: `var(--${color}-light)` }}
        ></div>
      </div>
      
      {/* Right Side - Count/Main Value */}
     
    </div>
    
    {/* Bottom Subheading */}
    <div className="shimmer-bottom-section">
      <div className="shimmer-subheading"></div>
    </div>
  </div>
);

// ChartSkeleton.jsx - Modern Chart Design
export const ChartSkeleton = () => (
  <div className="chart-shimmer-modern">
    <div className="chart-header-modern">
      <div className="chart-title-modern"></div>
      <div className="chart-controls-modern">
        <div className="control-item-modern"></div>
        <div className="control-item-modern"></div>
        <div className="control-item-modern"></div>
      </div>
    </div>
    
    <div className="chart-body-modern">
      <div className="y-axis-modern">
        <div className="y-tick"></div>
        <div className="y-tick"></div>
        <div className="y-tick"></div>
        <div className="y-tick"></div>
        <div className="y-tick"></div>
      </div>
      
      <div className="chart-graph-modern">
        <div className="grid-lines-modern">
          <div className="grid-line"></div>
          <div className="grid-line"></div>
          <div className="grid-line"></div>
          <div className="grid-line"></div>
        </div>
      
      </div>
    </div>
    
    <div className="x-axis-modern">
      {[...Array(8)].map((_, i) => (
        <div key={i} className="x-label-modern"></div>
      ))}
    </div>
  </div>
);


export const ProfileSkeleton = () => {
  return (
    <div className="ps-wrapper">
      {/* Left Image */}
      <div className="ps-left">
        <div className="ps-skeleton ps-avatar"></div>
      </div>

      {/* Right Content */}
      <div className="ps-right">
        <div className="ps-row">
          <div className="ps-skeleton ps-input"></div>
          <div className="ps-skeleton ps-input"></div>
          <div className="ps-skeleton ps-edit-btn"></div>
        </div>

        <div className="ps-skeleton ps-role"></div>

        <div className="ps-bottom">
          <div className="ps-skeleton ps-price"></div>
          <div className="ps-skeleton ps-update-btn"></div>
        </div>
      </div>
    </div>
  );
};

export const InstitutionProfileSkeleton = () => {
  return (
    <div className="inst-skel-container">
      {/* LEFT – Logo & Thumbnail */}
      <div className="inst-skel-left">
        <div className="inst-skel-circle shimmer"></div>
        <div className="inst-skel-thumb shimmer"></div>
      </div>

      {/* CENTER – Form */}
      <div className="inst-skel-form">
        <div className="inst-skel-textarea shimmer"></div>

        <div className="inst-skel-color-row shimmer"></div>

        <div className="inst-skel-row">
          <div className="inst-skel-input shimmer"></div>
          <div className="inst-skel-btn shimmer"></div>
        </div>

        <div className="inst-skel-grid">
          <div className="inst-skel-input shimmer"></div>
          <div className="inst-skel-input shimmer"></div>
          <div className="inst-skel-input shimmer"></div>
          <div className="inst-skel-input shimmer"></div>
        </div>
      </div>

      {/* RIGHT – Preview Card */}
      <div className="inst-skel-preview shimmer"></div>
    </div>
  );
};



export default TableSkeleton;